import { COMPARISON_BINARY_OPERATORS } from '@babel/types';
import React,{useState, useEffect} from 'react'
import {useParams,useHistory} from "react-router-dom";
import Footer from '../../Components/Footer';
import NavBar from '../../Components/NavBar';
import api from "../../lib/api"
import PostCard from '../../Components/MainPostCard';

//modificamos la prop que MainCardPost
export default function Search() {
    const { keyword } = useParams();
    console.log(keyword)
    const history = useHistory()

    //esta funcion es para manejar el input en el navBar
    const [search,setSearch]=useState(keyword)
    function getSearch(value){
        setSearch(value)
        console.log(value)
    }   
    //esta logica es para manejar el input que esta fuera del navbar
    //esto esta re feo pero funciona =(
    const [inputValue,setInputValue] = useState("");
    function handleInputValue(event){
        setInputValue(event.target.value)
    }
    function handleEnter(event){
        if(event.key=="Enter"){
            history.push(`/search/${inputValue}`)
			getSearch(inputValue)
        }
    }
    const [posts,setPost] = useState([]);
    const [condition,setCondition] = useState("");
    const filterBySearch = posts => posts.filter(post=>{
        const searchString = `${post.user.name.toLowerCase() } ${post.title.toLowerCase() } ${post.tag_list.join(" ").toLowerCase()}`
        return searchString.includes(search.toLowerCase()) 
    })
    const orderByOldest = posts => [...posts].sort((a,b)=>new Date(a.createdAt).getTime()-new Date(b.createdAt).getTime());
    const orderByLatest = posts => [...posts].sort((a,b)=>new Date(b.createdAt).getTime()-new Date(a.createdAt).getTime());
    const orderByRelevance = posts => [...posts].sort((a,b)=>b.positive_reactions_count - a.positive_reactions_count);

    useEffect(async () => {
        const response = await api.getAllPosts()
        console.log(response.data.posts);
        const posts = response.data.posts;
        setPost(filterBySearch(posts));

    },[])

    useEffect(async () => {
        const response = await api.getAllPosts()
        console.log(response.data.posts);
        const posts = response.data.posts;
        setPost(filterBySearch(posts));

    },[search])

    useEffect(() => {
        switch(condition){
            case  "Most Relevant":
            setPost(orderByRelevance(posts));
            break;
            case "Newest":
            setPost(orderByLatest(posts));
            break;
            case "Oldest":
            setPost(orderByOldest(posts));
            break;
        }
    }, [condition])
    
    {/*onChange={handleSearch} onKeyPress={handleKey} value={search}*/}
    return (
        <>
            <NavBar getSearch={getSearch}/>
            <main class="container-sm custom-container">

		<div class="row">
			{/*-------------------------------------------------------------------ASIDE LEFT-----------------------------------------------------------------------------------------*/}
			<aside class="d-md-block  col-12 col-md-4 col-lg-3 ">
			{/*--aqui esta el input de busqueda--*/}
            <form className="seach d-md-none" onSubmit={(e)=>e.preventDefault()}>
				<input id="search" className="form-control mb-2"  type="search" placeholder="Search..."
				aria-label="Search..."
                onChange={handleInputValue}
                onKeyPress={handleEnter}
                value={inputValue}
                />
			</form>
    
                <h3 class="font-weight-bold text-md-center ml-md-n4">Search results</h3>
                <ul class="d-flex icons section-list collapse ml-n5 ml-md-0 " id="section-list" aria-expanded="false">
					<a href="#" class="item-list  list-group-item-light">Posts</a>
					<a href="#" class="item-list">Podcasts</a>
					<a href="#" class="item-list">People</a>
					<a href="#" class="item-list">Comments</a>
					<a href="#" class="item-list">My posts only</a>
					
                </ul>
			</aside>
			{/*------------------------------------------------------------------------MAIN CARDS---------------------------------------------------------------------------*/}
    
            <section class="col-12 col-md-7 col-lg-8 cards-section  ">

				<nav class="cards-navigation">
					<div class="title">
						<h1 class="subtitle ">Posts</h1>
					</div>
					<div class="nav nav-tabs" id="nav-tab" role="tablist">
						<button class="nav-link active" id="relevance" data-toggle="tab" href="#nav-feed"
							role="tab" aria-controls="nav-feed" aria-selected="true"
                            onClick={()=>setCondition("Most Relevant")}
                            >Most Relevant</button>
						<button class="nav-link" id="newest" data-toggle="tab" href="#nav-week"
							role="tab" aria-controls="nav-week" aria-selected="false"
                            onClick={()=>setCondition("Newest")}
                            >Newest</button>
						<button class="nav-link" id="oldest" data-toggle="tab" href="#nav-month"
							role="tab" aria-controls="nav-month" aria-selected="false"
                            onClick={()=>setCondition("Oldest")}
                            >Oldest</button>

					</div>
				</nav>
				<div class="tab-content" id="nav-tabContent">
					<div class="tab-pane fade show active" id="nav-feed" role="tabpanel" aria-labelledby="nav-feed-tab">
                    {posts.map((post,index)=>{
                        return <PostCard key={index} 
                        _id={post._id}
                        image={post.cover_image}
                        name={post.user.name}
                        readable_publish_date={post.readable_publish_date}
                        title={post.title}
                        positive_reactions_count={post.positive_reactions_count}
                        reading_time_minutes={post.reading_time_minutes}
                        tag_list={post.tag_list}
                        tags={post.tags}
                        display={index==0?"d-block":"d-none"}
                        />
        })}
                    
                    </div>
                </div>
            </section>
        </div>
	</main>
            
            <Footer />

        </>
    )
}
